module.exports = __webpack_public_path__ + "static/media/c1a@2x.5fdf8cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/plans/c1a@2x.png
// module id = 283
// module chunks = 0